var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'lds-ring-' + _vm.size},[_c('div',{style:(_vm.ringStyles)}),_c('div',{style:(_vm.ringStyles)}),_c('div',{style:(_vm.ringStyles)}),_c('div',{style:(_vm.ringStyles)})])}
var staticRenderFns = []

export { render, staticRenderFns }